'use client';
import { isString } from '@s7/utils';

const primaryShade = (raw, options)=>{
    if (isString(raw)) {
        return raw;
    }
    const { /*
         * primary - для цвета text;
         * content - для цвета background;
         * element - для цвета border;
         * */ keys = [
        'base',
        600,
        100,
        'primary',
        'content',
        'element'
    ], fallback = '#000' } = options || {};
    for (const key of keys){
        if (key in raw) {
            return raw[key];
        }
    }
    return fallback;
};

export { primaryShade };
//# sourceMappingURL=primaryShade.js.map
